<template>
  <div>
    <el-dialog
      title="Hoàn tiền"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="1000px"
      @close="onCloseDialog()"
    >
      <validation-observer ref="formValidator">
        <el-tabs
          v-model="tabIndex"
          tab-position="left"
          style="height: 400px"
          @tab-click="onTabClick"
        >
          <el-tab-pane
            v-for="(item, index) in refundConfigs"
            :key="index"
            :label="item.name"
          >
            <div class="das-form-container">
              <InfoList :columns="2">
                <InfoListLabel>
                  <span class="label">Ngày</span>
                </InfoListLabel>
                <InfoListValue style="width: 260px">{{
                  $displayDate(new Date())
                }}</InfoListValue>

                <InfoListLabel>
                  <span class="label">Trang giao dịch</span>
                </InfoListLabel>
                <InfoListValue style="width: 260px">{{
                  `${selectedTab?.label} - ${selectedTab?.desc}` || null
                }}</InfoListValue>

                <InfoListLabel>Tên khách</InfoListLabel>
                <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

                <InfoListLabel>Thu ngân</InfoListLabel>
                <InfoListValue>{{ userName ?? 'Unknown' }}</InfoListValue>

                <InfoListLabel v-if="refundType === 1"
                  >Loại hoàn tiền</InfoListLabel
                >
                <InfoListValue v-if="refundType === 1">
                  <template>
                    <div class="checkbox-container" style="gap: 0">
                      <div class="checks-wrap">
                        <input
                          id="cpSpdTp111"
                          v-model="refundForm.type"
                          :value="2"
                          type="radio"
                          @change="onRefundTypeChanged"
                        />
                        <label for="cpSpdTp111">Số tiền</label>
                      </div>
                      <div class="checks-wrap">
                        <input
                          id="cpSpdTp222"
                          v-model="refundForm.type"
                          :value="1"
                          type="radio"
                          @change="onRefundTypeChanged"
                        />
                        <label for="cpSpdTp222">Phần trăm</label>
                      </div>
                    </div>
                  </template>
                </InfoListValue>

                <InfoListLabel v-if="refundType === 1">
                  <span class="label">Số dư hóa đơn</span>
                </InfoListLabel>
                <InfoListValue v-if="refundType === 1">
                  <div class="flex gap-10">
                    {{ $displayCurrency(initInvoiceAmount) }} VND
                  </div>
                </InfoListValue>

                <InfoListLabel v-if="refundForm.type === 2 && refundType === 1">
                  <span class="label-required">Số tiền hoàn</span>
                </InfoListLabel>
                <InfoListValue v-if="refundForm.type === 2 && refundType === 1"
                  ><div style="display: flex; align-items: center; gap: 10px">
                    <validation-provider
                      style="flex: 2"
                      rules="required"
                      name="Số tiền hoàn"
                    >
                      <VxCurrencyInput v-model="refundForm.money" type="text" />
                    </validation-provider>
                    <el-select
                      v-model="refundForm.currency_id"
                      style="flex: 1"
                      placeholder=""
                    >
                      <el-option
                        v-for="item1 in currencyOptions"
                        :key="item1.id"
                        :label="item1.code"
                        :value="item1.id"
                      >
                      </el-option>
                    </el-select></div
                ></InfoListValue>

                <InfoListLabel v-if="refundForm.type === 1">
                  <span class="label-required">Phần trăm(%)</span>
                </InfoListLabel>
                <InfoListValue v-if="refundForm.type === 1">
                  <div class="flex gap-10">
                    <validation-provider
                      rules="required|number|percent"
                      name="Phần trăm"
                      style="flex: 1"
                    >
                      <input
                        v-model="refundForm.percent"
                        v-numeric-only
                        :title="percentTooltip"
                        type="text"
                      />
                      <!--:disabled="!invoiceAmountId" -->
                    </validation-provider>
                    <div class="read-only-input" style="flex: 2">
                      {{ $displayCurrency(calculatedInvoiceAmount) || 0 }} VND
                    </div>
                  </div>
                </InfoListValue>

                <!-- <InfoListLabel v-if="refundType === 1">
                  <span class="label-required">Chọn giao dịch</span>
                </InfoListLabel>
                <InfoListValue v-if="refundType === 1">
                  <validation-provider rules="required" name="Chọn giao dịch">
                    <el-select
                      v-model="invoiceAmountId"
                      style="flex: 1"
                      placeholder=""
                      @change="changeInvoiceAmountId($event)"
                    >
                      <el-option
                        v-for="ivc in invoiceAmountOptions"
                        :key="ivc.id"
                        :label="`${ivc.description} - ${$displayCurrency(
                          ivc.money
                        )} VNĐ`"
                        :value="ivc.id"
                      >
                      </el-option>
                    </el-select>
                  </validation-provider>
                </InfoListValue> -->

                <InfoListLabel
                  ><span class="label-required">Loại</span></InfoListLabel
                >
                <InfoListValue>
                  <validation-provider rules="required" name="Loại">
                    <el-select
                      v-model="refundForm.sub_transaction_id"
                      placeholder=""
                    >
                      <el-option
                        v-for="item1 in paymentOptions"
                        :key="item1.c_sub_transaction_id"
                        :label="`${item1.c_sub_transaction_nm} - ${item1.c_sub_transaction_desc}`"
                        :value="item1.c_sub_transaction_id"
                      >
                      </el-option>
                    </el-select>
                  </validation-provider>
                </InfoListValue>
                <InfoListLabel v-if="refundType === 1"
                  >Số hoàn khả dụng</InfoListLabel
                >
                <InfoListValue v-if="refundType === 1"
                  ><span class="value" style="color: #357456; font-weight: 700"
                    >{{ $displayCurrency(leftSurplusAmount) || 0 }} VND</span
                  ></InfoListValue
                >
                <InfoListLabel v-if="refundType === 2"
                  >Số tiền hoàn là</InfoListLabel
                >
                <InfoListValue v-if="refundType === 2"
                  ><span class="value" style="color: #357456; font-weight: 700"
                    >{{ $displayCurrency(refundForm.money) || 0 }} VND</span
                  ></InfoListValue
                >
                <template v-if="tabIndex === '1' || tabIndex === '2'">
                  <InfoListLabel
                    ><span class="label-required"
                      >Tên ngân hàng</span
                    ></InfoListLabel
                  >
                  <InfoListValue>
                    <validation-provider
                      rules="required|max:50"
                      name="Tên ngân hàng"
                    >
                      <input
                        v-model="refundForm.bank_account_nm"
                        type="text"
                        style="flex: 1"
                      />
                    </validation-provider>
                  </InfoListValue>
                </template>
                <!-- Transfer Payment -->
                <template v-if="tabIndex === '1'">
                  <InfoListLabel
                    ><span class="label-required"
                      >Số tài khoản</span
                    ></InfoListLabel
                  >
                  <InfoListValue>
                    <validation-provider
                      rules="required|number|max:20"
                      name="Tài khoản nhận"
                    >
                      <input
                        v-model="refundForm.bank_account_id"
                        v-numeric-only
                        type="text"
                        style="flex: 1"
                      />
                    </validation-provider>
                  </InfoListValue>
                </template>
                <!-- Card -->
                <template v-if="tabIndex === '2'">
                  <InfoListLabel
                    ><span class="label-required">Số thẻ</span></InfoListLabel
                  >
                  <InfoListValue>
                    <validation-provider
                      rules="required|number|max:20"
                      name="Số thẻ"
                    >
                      <input
                        v-model="refundForm.card_num"
                        type="text"
                        style="flex: 1"
                      />
                    </validation-provider>
                  </InfoListValue>
                </template>
                <template v-if="tabIndex !== '0'">
                  <InfoListLabel>
                    <span class="label-required">Tên tài khoản</span>
                  </InfoListLabel>
                  <InfoListValue>
                    <validation-provider
                      rules="required|max:200"
                      name="Tên tài khoản"
                    >
                      <input
                        v-model="refundForm.bank_account_name"
                        type="text"
                        style="flex: 1"
                      />
                    </validation-provider>
                  </InfoListValue>
                </template>
                <InfoListLabel>
                  <span class="label-required">Ghi chú</span>
                </InfoListLabel>
                <InfoListValue>
                  <validation-provider rules="required|max:200" name="Ghi chú">
                    <textarea
                      v-model="refundForm.note"
                      style="width: 100%"
                      :rows="3"
                    />
                  </validation-provider>
                </InfoListValue>
              </InfoList>
            </div>
          </el-tab-pane>
        </el-tabs>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            Đóng
          </button>
          <button
            :disabled="leftSurplusAmount < 0 && refundType === 1"
            class="btn primary small"
            @click="submitRefundForm"
          >
            Hoàn tiền
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAllCurrencyApi } from '@/api/common/currency'
import {
  getTransactionConfig,
  getMoneyRefundApi,
  // eslint-disable-next-line no-unused-vars
  submitRefundFormApi
} from '@/api/cashier_service/postTransaction'
export default {
  props: {
    types: {
      type: String,
      default: null
    }
    // keyA: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      refundType: 1,
      invoiceAmountId: null,
      invoiceAmountOptions: [],
      dialogFormVisible: false,
      tabIndex: '0',
      initInvoiceAmount: 0,
      tempInvoiceAmount: 0,
      refundInitAmount: 0,
      refundForm: {
        type: 2,
        money: null,
        note: null,
        percent: null,
        sub_booking_group_id: null,
        sub_transaction_id: null,
        trans_date: this.$moment(new Date()).format('YYYY-MM-DD'),
        trans_page: null,
        invoice_number_sequence: null,
        currency_id: 5,
        card_num: null,
        bank_account_id: null,
        bank_account_name: null,
        debt_account_id: null,
        bank_account_nm: null,
        folio_num: null
      },
      payments: [],
      currencyOptions: [],
      paymentOptions: [],
      paymentMethods: [],
      isVTab: false,
      paymentTransactionConfig: [],
      // paymentConfigs: [
      //   {
      //     name: 'Tiền mặt'
      //   },
      //   {
      //     name: 'Chuyển khoản'
      //   },
      //   {
      //     name: 'Công nợ'
      //   },
      //   {
      //     name: 'Thẻ'
      //   }
      // ],
      refundConfigs: [
        {
          name: 'Tiền mặt'
        },
        {
          name: 'Chuyển khoản'
        },
        {
          name: 'Thẻ'
        }
      ]
    }
  },
  computed: {
    // tabList() {
    //   return this.$store.getters['tabList']
    // },
    allTranPages() {
      return this.$store.getters['allTranPages']
    },
    bookingInfo() {
      return this.$store.getters['cashier']
    },
    selectedTab() {
      return this.$store.getters['selectedTab']
    },
    transactions() {
      return this.$store.getters['transactions']
    },
    userName() {
      return this.$store.getters['full_name']
    },
    calculatedInvoiceAmount() {
      return 0.01 * this.refundForm.percent * this.tempInvoiceAmount || 0
    },
    leftSurplusAmount() {
      let amount = 0
      if (this.refundForm.type === 1) {
        // %
        amount = this.calculatedInvoiceAmount
      } else {
        // so tien
        amount = Number(this.refundForm.money)
      }
      return Number(this.refundInitAmount) - amount
    },
    percentTooltip() {
      if (!this.invoiceAmountId) {
        return 'Chọn giao dịch trước, sau đó nhập % hoàn tiền'
      } else {
        return null
      }
    }
  },
  watch: {
    // tabIndex() {
    //   alert(this.tabIndex)
    // },
    // async keyA() {
    //   await this.getMoneyRefund()
    // },
    leftSurplusAmount(value) {
      // this.$emit('surplusChanged', value)
    },
    calculatedInvoiceAmount: {
      handler(newValue) {
        if (newValue !== this.refundForm.money && this.refundForm.type === 1) {
          this.refundForm.money = newValue
        }
      },
      immediate: true
    }
  },
  async mounted() {},
  methods: {
    onCloseDialog() {
      this.onResetData()
      this.refundForm.money = null
      this.invoiceAmountId = null
    },
    // changeInvoiceAmountId(id) {
    //   if (id) {
    //     const ele = this.invoiceAmountOptions.filter(item => id === item.id)
    //     this.refundForm.folio_num = ele[0].folio_num || null
    //     this.tempInvoiceAmount = ele[0].money
    //   } else {
    //     this.tempInvoiceAmount = this.initInvoiceAmount
    //   }
    // },
    onRefundTypeChanged() {
      this.refundForm.percent = null
      this.refundForm.money = null
      this.invoiceAmountId = null
    },
    async openDialog(refundTp) {
      await this.getMoneyRefund(refundTp)
      await this.getTransactionConfigList()
      await this.getAllCurrency()
      this.dialogFormVisible = true
    },
    onResetData() {
      const data = {
        type: 2,
        note: null,
        percent: null,
        sub_booking_group_id: null,
        sub_transaction_id: null,
        trans_date: this.$moment(new Date()).format('YYYY-MM-DD'),
        trans_page: null,
        invoice_number_sequence: null,
        currency_id: 5,
        card_num: null,
        bank_account_id: null,
        debt_account_id: null,
        bank_account_name: null,
        folio_num: null
      }
      Object.assign(this.refundForm, data)
      // refundType === 2 not remote money
      if (this.refundType === 1) {
        this.refundForm.money = null
      }
    },
    async submitRefundForm() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      const data = {
        ...this.refundForm,
        invoice_number_sequence: this.transactions[0].invoice_number_sequence,
        sub_booking_group_id: this.bookingInfo.id,
        room_transaction_id_refund: this.transactions[0].id,
        trans_page: this.selectedTab?.value || null,
        deposit_transaction_ids:
          this.refundType === 2 ? this.transactions.map(item => item.id) : null
      }
      await submitRefundFormApi(data)
        .then(async res => {
          const message = res.message
          this.dialogFormVisible = false
          this.$store.dispatch('cashier/changeTransactionListIndex')
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async getMoneyRefund(type) {
      this.refundType = type
      if (type === 1) {
        const params = {
          id: this.transactions[0].id || null
          // invoiceSeq: this.transactions[0].invoice_number_sequence || null
          // subBookingGroupId: this.bookingInfo.id,
          // transPage: this.selectedTab?.value || null
        }
        // await this.getDebtAccounts()
        const data = await getMoneyRefundApi(params)
        this.refundInitAmount = data.data.surplus || 0
        this.initInvoiceAmount = data.data.total_invoice || 0
        this.tempInvoiceAmount = data.data.total_invoice || 0
        // this.invoiceAmountOptions = data.data.data.map((item, index) => {
        //   return {
        //     ...item,
        //     id: index + 1
        //   }
        // })
      } else {
        const money = this.transactions.reduce((a, b) => {
          return a + Math.abs(b.money)
        }, 0)
        this.refundForm.money = money
        // this.initInvoiceAmount = money
      }
    },
    async getTransactionConfigList() {
      const paymentData = await getTransactionConfig({ type: 3 })
      this.paymentTransactionConfig = paymentData?.data || []
      this.paymentOptions = this.paymentTransactionConfig.filter(
        item => item.method_nm === 'CASH_REFUND'
      )
      this.refundForm.sub_transaction_id =
        this.paymentOptions[0].c_sub_transaction_id
    },
    async getAllCurrency() {
      const data = await getAllCurrencyApi()
      this.currencyOptions = data?.data || []
    },
    onTabClick(params) {
      this.onResetData()
      switch (Number(params.index)) {
        case 0:
          this.paymentOptions = this.paymentTransactionConfig.filter(
            item => item.method_nm === 'CASH_REFUND'
          )
          this.isVTab = true
          break
        case 1:
          this.paymentOptions = this.paymentTransactionConfig.filter(
            item => item.method_nm === 'TRANSFER_REFUND'
          )
          break
        case 2:
          this.paymentOptions = this.paymentTransactionConfig.filter(
            item => item.method_nm === 'CREDIT_REFUND'
          )
          break
        default:
          break
      }
      this.refundForm.sub_transaction_id =
        this.paymentOptions[0].c_sub_transaction_id

      // this.tab = params.index
    }
  }
}
</script>

<style lang="scss" scoped>
.read-only-input {
  height: 32px;
  line-height: 32px;
  border: 1px solid #d8dee5;
  border-radius: 5px;
  user-select: none;
  cursor: not-allowed;
  padding: 0 5px;
}
</style>
